import React from 'react';
import { QuoteIcon } from 'lucide-react';
import { PageHero } from '../components/PageHero';
import { Stars } from '../components/Stars';
import { FinalCta } from '../components/FinalCta';
import { reviews } from '../data/reviews';
export function ReviewsPage() {
  return <>
      <PageHero crumbs={[{
      label: 'Reviews'
    }]} title={<>
            Customer <span className="text-brand" data-id="element-506" data-mp="weplal8dewyr">reviews</span>
          </>} intro="What Las Vegas homeowners and businesses say about working with Home Repair MD." data-id="element-505" data-mp="8olujega6rp6" />

      <section className="bg-white py-20 lg:py-24" data-id="element-507" data-mp="11b6l4coxmzro">
        <div className="mx-auto max-w-7xl px-5 lg:px-8" data-id="element-508" data-mp="ncq4nu19puwc">
          <ul className="grid gap-6 md:grid-cols-3" data-id="element-509" data-mp="rfd004x5dxya">
            {reviews.map(r => <li key={r.name} data-id="element-510" data-mp="rh7nnqzt0462">
                <figure className="flex h-full flex-col rounded-2xl bg-canvas p-7" data-id="element-511" data-mp="383h1ywlbh5gs">
                  <div className="flex items-center justify-between gap-4" data-id="element-512" data-mp="3c5c6e9yjnyys">
                    <QuoteIcon className="h-8 w-8 text-brand" aria-hidden="true" data-id="element-513" data-mp="3c395guvuslfa" />
                    <Stars data-id="element-514" data-mp="2pzmtu0qvx7y" />
                  </div>
                  <p className="mt-5 font-display text-2xl font-bold text-ink" data-id="element-515" data-mp="3twkd3biz713x">{r.title}</p>
                  <blockquote className="mt-2 text-lg leading-relaxed text-ink-muted" data-id="element-516" data-mp="bqxi9nx4awex">“{r.quote}”</blockquote>
                  <figcaption className="mt-auto border-t border-line pt-5" data-id="element-517" data-mp="7okntvntmkxg">
                    <span className="block font-bold text-ink" data-id="element-518" data-mp="lobx5j3e7d54">{r.name}</span>
                    <span className="text-sm text-ink-muted" data-id="element-519" data-mp="lm8y69k9i9o9">{r.location}</span>
                  </figcaption>
                </figure>
              </li>)}
          </ul>
        </div>
      </section>

      <FinalCta data-id="element-520" data-mp="qfbugpgfbx85" />
    </>;
}